module.exports = __webpack_public_path__ + "static/yt_4@1x-d25b0f2fe9f5853e0438801c953f3d74.jpg";